import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/createSuper";
var _excluded = ["theme", "classes", "icon", "popoverIcon", "variant", "loading", "active", "disabled", "children", "title", "className"],
  _excluded2 = ["variant", "color"];
import * as React from 'react';
import clsx from 'clsx';
import { Base, Interactive, Text } from '../../components/Base';
import { SrOnly } from '../../components/Helper';
import Spinner from '../../components/Spinner';
import Svg from '../../components/Svg';
var styles = {
  "root": "Action-root_1sbvN Widget-widgetFluidHeight_3_KT_ Widget-centered_2NDSy",
  "icon": "Action-icon_1pHHW",
  "label": "Action-label_3TGWM",
  "compact": "Action-compact_2mm0U Widget-widget__NYoi Widget-base_2xffH Widget-widgetFixedWidth_aNuHK",
  "wide": "Action-wide_2Biwb Widget-xsm-widget_TtU9B Widget-base_2xffH",
  "block": "Action-block_3MKJH",
  "wrapper": "Action-wrapper_3wPf7",
  "withPopover": "Action-withPopover_3n254",
  "isDisabled": "Action-isDisabled_2A6Lq",
  "base-white": "Action-base-white_3Be7f",
  "base-green": "Action-base-green_211wh",
  "base-success": "Action-base-success_3VFIl",
  "base-danger": "Action-base-danger_1Xr3W",
  "base-disabled": "Action-base-disabled_b3RtN",
  "hover-green": "Action-hover-green_3Q75t",
  "hover-green-dark": "Action-hover-green-dark_21qiE",
  "hover-success": "Action-hover-success_1Y4nS",
  "hover-success-dark": "Action-hover-success-dark_3XEeO",
  "hover-danger": "Action-hover-danger_1UwXc",
  "hover-danger-dark": "Action-hover-danger-dark_VEh7y"
};
var svgStyles = {
  "root": "SVG-root_1gLEH",
  "fill-white": "SVG-fill-white_1ifIm",
  "fill-green": "SVG-fill-green_3XEHx",
  "fill-blue": "SVG-fill-blue_3XxuW",
  "fill-grey-lighter": "SVG-fill-grey-lighter_ZsArp",
  "fill-grey-light": "SVG-fill-grey-light_2xlhv",
  "fill-grey": "SVG-fill-grey_BVkZ6",
  "fill-grey-dark": "SVG-fill-grey-dark_BCV7H",
  "fill-grey-darker": "SVG-fill-grey-darker_24g8W",
  "fill-anthracite": "SVG-fill-anthracite_7Va6z",
  "fill-yellow": "SVG-fill-yellow_1DmnQ",
  "fill-yellow-dark": "SVG-fill-yellow-dark_oJJ2l",
  "fill-yellow-darker": "SVG-fill-yellow-darker_3Tu8T",
  "fill-red": "SVG-fill-red_1zjVE",
  "fill-info": "SVG-fill-info_dJHzJ",
  "fill-success": "SVG-fill-success_2sUEP",
  "fill-warning": "SVG-fill-warning_3l7NA",
  "fill-danger": "SVG-fill-danger_3h58E",
  "fill-progress": "SVG-fill-progress_1wmR1 SVG-fill-info_dJHzJ",
  "fill-unknown": "SVG-fill-unknown_cu2te SVG-fill-grey-dark_BCV7H",
  "fill-disabled": "SVG-fill-disabled_2Wv9a SVG-fill-grey_BVkZ6"
};
/**
 * Themes map.
 * We try to control/compose precisely which classes are added.
 * If a theme does not provides a `hover` key, the class won't be added.
 */
var themesMap = {
  green: {
    base: 'white',
    color: 'base',
    fill: 'green',
    hover: 'green'
  },
  'green-plain': {
    base: 'green',
    color: 'white',
    fill: 'white',
    hover: 'green-dark'
  },
  success: {
    base: 'white',
    color: 'base',
    fill: 'success',
    hover: 'success'
  },
  'success-plain': {
    base: 'success',
    color: 'white',
    fill: 'white',
    hover: 'success-dark'
  },
  danger: {
    base: 'white',
    color: 'base',
    fill: 'danger',
    hover: 'danger'
  },
  'danger-plain': {
    base: 'danger',
    color: 'white',
    fill: 'white',
    hover: 'danger-dark'
  },
  disabled: {
    base: 'disabled',
    color: 'grey',
    fill: 'disabled'
  }
};
var Action = /*#__PURE__*/function (_React$Component) {
  _inherits(Action, _React$Component);
  var _super = _createSuper(Action);
  function Action() {
    var _this;
    _classCallCheck(this, Action);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * Helper: allow to pass classes to component childs.
     */
    _this.classOf = function (key) {
      var _this$props$classes$k, _this$props$classes;
      return (_this$props$classes$k = (_this$props$classes = _this.props.classes) === null || _this$props$classes === void 0 ? void 0 : _this$props$classes[key]) !== null && _this$props$classes$k !== void 0 ? _this$props$classes$k : '';
    };
    return _this;
  }
  _createClass(Action, [{
    key: "computeTheme",
    value:
    /**
     * Compute rendering local theme based on props.
     */
    function computeTheme() {
      var themeName = this.props.disabled || this.props.loading ? 'disabled' : this.props.theme;
      return themesMap[themeName];
    }

    /**
     * Compute the addon to render based on props.
     */
  }, {
    key: "computeAddon",
    value: function computeAddon() {
      // The Loader prevail over the others.
      if (this.props.loading) {
        return 'loader';
      }

      // The PopoverIcon prevail over the icon.
      if (_typeof(this.props.popoverIcon) === 'object' && /block|wide/.test(this.props.variant) && this.props.disabled) {
        return 'popover';
      }
      if (typeof this.props.icon === 'string' && Svg.has(this.props.icon)) {
        return 'icon';
      }
      return '';
    }

    /**
     * Add a fallback `title` property for the `compact` variant.
     */
  }, {
    key: "computeTitle",
    value: function computeTitle() {
      if (typeof this.props.title === 'string') {
        return this.props.title;
      }
      if (this.props.variant === 'compact' && typeof this.props.children === 'string') {
        return this.props.children;
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        theme = _this$props.theme,
        classes = _this$props.classes,
        icon = _this$props.icon,
        popoverIcon = _this$props.popoverIcon,
        variant = _this$props.variant,
        loading = _this$props.loading,
        active = _this$props.active,
        disabled = _this$props.disabled,
        children = _this$props.children,
        title = _this$props.title,
        className = _this$props.className,
        extraProps = _objectWithoutProperties(_this$props, _excluded);
      var computedTheme = this.computeTheme();
      var computedTitle = this.computeTitle();
      var addon = this.computeAddon();
      var hasLoader = addon === 'loader';
      var hasPopover = addon === 'popover';
      var hasIcon = addon === 'icon';
      var isDisabled = disabled || hasLoader;
      var isBlock = variant === 'block';
      var rootClasses = clsx(styles.root, styles[variant], computedTheme.base && styles["base-".concat(computedTheme.base)], computedTheme.hover && styles["hover-".concat(computedTheme.hover)], !hasPopover && isDisabled && styles.isDisabled, hasPopover && styles.withPopover, this.classOf('root'), className);
      var wrapperClasses = clsx(styles.wrapper, this.classOf('wrapper'));
      var labelClasses = clsx(styles.label, this.classOf('label'));
      var iconClasses = clsx(styles.icon, computedTheme.fill && svgStyles["fill-".concat(computedTheme.fill)], this.classOf('icon'));
      return (
        /*#__PURE__*/
        // $FlowFixMe[cannot-spread-inexact]
        React.createElement(Interactive, _extends({
          tagName: hasPopover ? 'span' : undefined,
          hoverable: !!computedTheme.hover,
          interactive: !!computedTheme.hover,
          title: computedTitle,
          disabled: isDisabled,
          separatorLeft: !isBlock,
          className: rootClasses
        }, extraProps), /*#__PURE__*/React.createElement(Base, {
          tagName: "span",
          flex: true,
          flexGrow1: true,
          flexAlignItemsCenter: true,
          flexJustifyCenter: !isBlock,
          flexJustifyBetween: isBlock,
          paddingRight: isBlock ? 'small' : null,
          paddingLeft: isBlock ? 'small' : null,
          className: wrapperClasses
        }, /*#__PURE__*/React.createElement(Label, {
          variant: variant,
          color: computedTheme.color,
          className: labelClasses
        }, children), hasLoader && /*#__PURE__*/React.createElement(Spinner, {
          name: "dots"
        }), hasIcon && icon && /*#__PURE__*/React.createElement(Svg, {
          name: icon,
          className: iconClasses,
          focusable: "false"
        }), hasPopover && popoverIcon && /*#__PURE__*/React.cloneElement(popoverIcon)))
      );
    }
  }]);
  return Action;
}(React.Component);
Action.defaultProps = {
  variant: 'compact',
  theme: 'green'
};
function Label(_ref) {
  var variant = _ref.variant,
    color = _ref.color,
    extraProps = _objectWithoutProperties(_ref, _excluded2);
  var component;
  if (variant === 'compact') {
    component = /*#__PURE__*/React.createElement(SrOnly, extraProps);
  }
  if (variant === 'wide') {
    // $FlowFixMe[cannot-spread-inexact]
    component = /*#__PURE__*/React.createElement(SrOnly, _extends({
      xsm: true
    }, extraProps));
  }
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Text, _extends({
      weight: "regular",
      align: "start",
      color: color,
      component: component
    }, extraProps))
  );
}
export default Action;